import React from 'react';
import { useMatchInfo } from '../ThongTinTranDau/MatchInfoContext';

import OddTableAnalysis from '../OddTableAnalysis';
import CollapsiblePanel from '../CollapsiblePanel';

const MatchAnalysisOdds = () => {

  const { oddData, liveOddData, match } = useMatchInfo();

  return (
    <CollapsiblePanel
      title="So sánh kèo trực tuyến"
    >
      <OddTableAnalysis data={oddData} dataLiveOdd={liveOddData} matchId={match.id} />
    </CollapsiblePanel>
  );
};

export default MatchAnalysisOdds;
